import { createRouter, createWebHashHistory, type Router, type RouteRecordRaw } from 'vue-router'
import authenticationRoutes from './Definitions/authentication.ts'
import contractRoutes from './Definitions/contract.ts'
import restructuringRoutes from './Definitions/restructuration.ts'
import simulationRoutes from './Definitions/simulation.ts'
import walletRoutes from './Definitions/wallet.ts'
import entityRoutes from './Definitions/entity.ts'
import userRoutes from './Definitions/user.ts'
import notificationRoutes from './Definitions/notifications.ts'
import { assertThat, guard } from './Guards'
import { Routes } from '../Constants/Routes.ts'
import HomePage from '../Views/HomePage.vue'

const routes: RouteRecordRaw[] = [
  ...authenticationRoutes,
  ...contractRoutes,
  ...walletRoutes,
  ...entityRoutes,
  ...restructuringRoutes,
  ...simulationRoutes,
  ...userRoutes,
  ...notificationRoutes,
  {
    name: Routes.HOME,
    path: '/',
    component: HomePage,
    meta: {
      guards: assertThat().authenticated(),
    },
  },
]

const router: Router = createRouter({
  history: createWebHashHistory(),
  routes,
})

router.beforeEach(guard)

export default router
